<template>
    <div class="e-env-banner" v-if="!hideDemo && (!isLive() || debugLive)" :class="[`env-${$env.VUE_APP_ENV}`, {'debug-live': debugLive}]">
        <div class="content" v-if="isVisible">
            <i class="fas fa-exclamation-triangle mx-1" v-if="debugLive"/>
            <span class="env-name">You are now working on <strong class="text-uppercase">{{$env.VUE_APP_ENV}}</strong></span>
            <i @click="close" class="fas fa-close ml-2"/>
        </div>
    </div>
</template>

<script>
import { getCookie, setCookie } from "../../helpers/utils.js";

/**
 * Simple component to add to the App.vue to display debug live and other environments
 */
export default {
    name: `e-env-banner`,
    data() {
        return {
            hideDemo: false,
            debugLive: false,
            lastEnv: null,
            visible: false
        }
    },
    computed: {
        isVisible() {
            return this.visible;
        }
    },
    mounted() {
        this.hideDemo = localStorage.getItem(`demo-mode`) === `true`;
        this.debugLive = this.getDebugMode() === `debug-live-mode`;
        this.lastEnv = getCookie(`last-env`);
        if (this.lastEnv !== window.env.VUE_APP_ENV || this.debugLive) {
            this.visible = true;
        } else {
            this.visible = getCookie(`cookie-hidden`) !== `true`;
        }
        setCookie(`last-env`, window.env.VUE_APP_ENV);

        // if (!this.debugLive) {
        setTimeout(() => {
            this.visible = false;
        }, this.debugLive ? 10 * 1000 : 6 * 1000);
        // }
    },
    methods: {
        close() {
            this.visible = false;
            setCookie(`cookie-hidden`, `true`, 48);
        }
    }
}
</script>

<style lang="scss" scoped>
.e-env-banner {
    position: fixed;
    z-index: 9999;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    color: white;
    min-height: 3px;
    background-color: black;
    background-image: linear-gradient(45deg, rgba(0, 0, 0, 0.1) 25%, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.1) 50%, rgba(0, 0, 0, 0.1) 75%, rgba(0, 0, 0, 0) 75%, rgba(0, 0, 0, 0));
    background-size: 20px 20px;

    .content {
        padding: 5px;
        padding-bottom: calc(5px + env(safe-area-inset-bottom));
    }

    .fa-close {
        opacity: 0.7;
        cursor: pointer;

        &:hover {
            opacity: 1;
        }
    }

    &.env-dev,
    &.env-local {
        background-color: #28a745;
    }

    &.env-next,
    &.env-devnext {
        background-color: #158fc3;
    }

    &.debug-live {
        background-color: #e52126;
    }
}
</style>
